// https://vuex.vuejs.org/en/state.html

export default {
    token: localStorage.getItem("user-token") || "",
    role: localStorage.getItem("user-role") || "",
    user: localStorage.getItem("user-name") || "",
    status: "",
};
